import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { RadioButton } from '@/components/residents/marketplace/shared/RadioButton';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_SPACING, REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';

interface Props {
  prompt: string;
  options: { id: number; label: string }[];
  selectedOptionId: number | undefined;
  onChange: (optionId: number) => void;
}

export const PollQuestionView: React.FC<Props> = ({
  prompt,
  options,
  selectedOptionId,
  onChange,
}) => {
  const { colors } = useThemeColors();
  return (
    <View style={styles.root}>
      <Text style={[REDESIGN_TYPOGRAPHY.cardTitle, { color: colors.text.primary }]}>{prompt}</Text>
      <View style={styles.options}>
        {options.map((o) => {
          const selected = o.id === selectedOptionId;
          return (
            <Pressable
              key={o.id}
              onPress={() => onChange(o.id)}
              accessibilityRole="radio"
              accessibilityState={{ selected }}
              accessibilityLabel={o.label}
              style={({ pressed }) => [
                styles.option,
                {
                  borderColor: selected ? colors.newsfeed.tagActiveBorder : colors.card.border,
                  backgroundColor: selected ? colors.newsfeed.tagActiveBg : colors.card.bg,
                  opacity: pressed ? 0.9 : 1,
                },
              ]}
            >
              <RadioButton isSelected={selected} size="medium" />
              <Text
                style={[
                  REDESIGN_TYPOGRAPHY.body,
                  {
                    color: selected ? colors.newsfeed.tagActiveText : colors.text.primary,
                    fontWeight: selected ? '600' : '400',
                    flexShrink: 1,
                  },
                ]}
              >
                {o.label}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: { gap: REDESIGN_SPACING.contentGap },
  options: { gap: REDESIGN_SPACING.sectionGap / 2 },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    borderWidth: 1,
    borderRadius: REDESIGN_SPACING.buttonRadius,
    paddingHorizontal: 14,
    paddingVertical: 12,
  },
});
